import React, { useMemo } from 'react';
import { useSelector, useDispatch } from '~/redux';
import content from '~/utils/contentAPI';
import crm from '~/utils/CRM_API';
import { localStorageKeys } from '~/utils/localStorageKeys';
import { actions } from '~/redux/reducers';
import { Redirect, useHistory } from 'react-router-dom';
import ReactGA from 'react-ga';
import axiosRetry from 'axios-retry';
import config from '~/config';
import axios from 'axios';

interface Props {
  as?: React.ElementType;
}
const LogOutLink: React.FC<Props> = ({ as }) => {
  // redux state
  const user = useSelector((state) => state.user);
  const entryParams = useSelector((state) => state.entryParams);
  const dispatch = useDispatch();
  const history = useHistory();

  const Tag = useMemo(() => as || 'button', [as] )

  function logout() {
    
    dispatch({
      type: actions.CLEAR_USER
    });
    dispatch({
      type: actions.CLEAR_RESOURCE_FAVS
    });
    content.clearUserToken();
    crm.clearToken();
    localStorage.removeItem(localStorageKeys.SID);
    localStorage.removeItem(localStorageKeys.refURL);

    // Google Analytics - unset the previously logged-in user
    ReactGA.set({ userId: ''});

    window.location.href = config.revanceSSOLogout.URL;
  }

  return user ? 
    <Tag onClick={() => logout()}><span>Log Out</span></Tag> : 
    <Redirect to='/login' />;
}

export default LogOutLink;



// WEBPACK FOOTER //
// ./src/components/links/LogOutLink.tsx